import { Component, Input } from '@angular/core';

/** 스타일이 중복되서 event style 사용 */
@Component({
  selector: '[appointment-holyday]',
  templateUrl: './appointment-holyday.component.html',
  styleUrls: ['./appointment-event.component.scss'],
})

export class AppointmentHolyday {

  /**
   * 내용
   * @type {string}
   */
  @Input('desc') desc: string = '';

  constructor() {}
}
